<template>
  <div>
    <section class="mn-top">
      <h2 class="txt-hide">메인 슬라이드</h2>
      <div class="slick top-slick">
        <div class="item" data-dot-title="<span>건강기능식품<strong>(신규)</strong></span><span><strong>영업신고</strong>를 위한 교육</span>" @click="goUrl('/usr/enroll/intro/1005')">
          <div class="wrap">
            <div class="top-info">
              <h3>
                건강기능식품
                <br />
                영업신고를 위한 교육(신규)
              </h3>
              <p>신규로 건강기능식품 영업신고를 하여야 하는 업체</p>
              <p class="fc-gr fs-sm">※ 교육 이수 후 수료증을 발급하여 해당 시·군·구청에 영업신고 후 영업을 하셔야 합니다.</p>
              <div class="top-btn-cont">
                <router-link to="/usr/bbs/10030/115598" class="btn-lg blue">
                  <i class="ico-vdo-wh"></i>
                  동영상안내
                </router-link>
                <router-link to="/usr/enroll/intro/1005" class="btn-lg red">교육신청</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="item" data-dot-title="<span>건강기능식품<strong>(보수)</strong></span><span><strong>기존영업자</strong>교육</span>" @click="goUrl('/usr/enroll/intro/1005')">
          <div class="wrap">
            <div class="top-info">
              <h3>건강기능식품 기존영업자 교육 (보수)</h3>
              <p>안전위생교육·보수</p>
              <p class="fc-gr">
                ※ 건강기능식품판매업 영업신고를 취득한 업체는 매년 안전위생보수교육을 이수하여야 합니다.
                <br />
                따라서
                <b>{{ $moment().year() }}년 보수교육</b>
                은
                <em>{{ $moment().year() }}년 3월부터 {{ $moment().year() }}년 12월 31일 이내</em>
                로 이수하여야 합니다.
              </p>
              <div class="top-btn-cont">
                <router-link to="/usr/bbs/10030/115599" class="btn-lg blue">
                  <i class="ico-vdo-wh"></i>
                  동영상안내
                </router-link>
                <router-link to="/usr/enroll/intro/1005" class="btn-lg red">교육신청</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="item" data-dot-title="<span>수입식품안전관리<strong>(신규)</strong></span><span><strong>영업자</strong>신규교육</span>" @click="goUrl('/usr/enroll/intro/1006')">
          <div class="wrap">
            <div class="top-info">
              <h3>
                수입식품안전관리
                <br />
                영업자 신규교육 (신규)
              </h3>
              <p>신규교육</p>
              <p class="fc-gr fs-sm">※ 영업을 하기 위해 미리 받아야 하는 교육</p>
              <div class="top-btn-cont">
                <router-link to="/usr/bbs/10030/115597" class="btn-lg blue">
                  <i class="ico-vdo-wh"></i>
                  동영상안내
                </router-link>
                <router-link to="/usr/enroll/intro/1006" class="btn-lg red">교육신청</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="item" data-dot-title="<span>수입식품안전관리<strong>(보수)</strong></span><span><strong>기존영업자</strong>보수교육</span>" @click="goUrl('/usr/enroll/intro/1006')">
          <div class="wrap">
            <div class="top-info">
              <h3>
                수입식품안전관리
                <br />
                기존영업자 보수교육 (보수)
              </h3>
              <p>보수교육</p>
              <p class="fc-gr fs-sm">※ 영업등록 후 그 다음해부터 매년 받아야 하는 교육</p>
              <div class="top-btn-cont">
                <router-link to="/usr/bbs/10030/115556" class="btn-lg blue">
                  <i class="ico-vdo-wh"></i>
                  동영상안내
                </router-link>
                <router-link to="/usr/enroll/intro/1006" class="btn-lg red">교육신청</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="slick-fnc">
        <div class="wrap">
          <button type="button" class="btn-prev"><span class="txt-hide">이전</span></button>
          <button type="button" class="btn-next"><span class="txt-hide">다음</span></button>
        </div>
      </div>
    </section>

    <div class="mn-contents">
      <div class="wrap">
        <div class="mn-row">
          <section class="mn-quick-top">
            <!-- <h2>바로가기</h2> -->
            <ul class="mn-quick-list">
              <li>
                <a href="https://www.youtube.com/channel/UC2TpWu4QvRwU3y8jU4jKwQA" target="_blank">
                  <span>협회 공식 유튜브</span>
                  <img :src="assetsURL + '/images/user2022/main/ico_youtube.svg'" alt="youtube" class="youtube" />
                </a>
              </li>
              <li>
                <a href="https://blog.naver.com/khff_info" target="_blank">
                  <span>협회 공식 네이버블로그</span>
                  <img :src="assetsURL + '/images/user2022/main/ico_blog.svg'" alt="blog" class="blog" />
                </a>
              </li>
              <li>
                <a href="http://pf.kakao.com/_xlgnJG/chat" target="_blank">
                  <span>교육도우미 챗봇</span>
                  <img :src="assetsURL + '/images/user2022/main/ico_kakao.png'" alt="kakao chatbot" class="foodinfo" />
                </a>
              </li>
              <li>
                <router-link to="/usr/bbs/10005/117492" class="btn-lg blue">
                  <span>건강기능식품 이상사례</span>
                  <img :src="assetsURL + '/images/user2022/main/ico_foodinfo.svg'" alt="KHSA" class="foodinfo" />
                </router-link>
              </li>
            </ul>
          </section>
        </div>
      </div>
      <div class="wrap">
        <div class="mn-row">
          <section class="mn-guide" v-if="!currentUser?.isAuthenticated">
            <h2 class="mn-tit">START GUIDE</h2>
            <ul>
              <li v-for="item in resultFaqList" :key="item.postsSeqno">
                <router-link :to="`/usr/bbs/10006/${item.postsSeqno}`">
                  <p>{{ item.title }}</p>
                </router-link>
              </li>
            </ul>
            <router-link to="/usr/bbs/10006" class="btn-more">
              자주하는 질문 더보기
              <i class="ico-arr-bar-r back"></i>
            </router-link>
          </section>

          <section class="mn-my" v-if="currentUser?.isAuthenticated">
            <h2 class="mn-tit">
              <em>{{ currentUser.userNm }}</em>
              님의 마이페이지
            </h2>
            <div class="my-area">
              <ul class="my-list">
                <li v-for="item in resultLearnList" :key="item.enrollNo">
                  <a @click="getMyClass(item)">
                    <span class="btn spot wfix" v-if="item.periodDiv == 'BEFORE'">
                      신청중
                      <i class="ico-arr-r wh back"></i>
                    </span>
                    <span class="btn spot3 wfix" v-if="item.periodDiv == 'EDU'">
                      학습하기
                      <i class="ico-arr-r wh back"></i>
                    </span>
                    <span class="btn spot2 wfix" v-if="(item.periodDiv == 'FINISH' || item.periodDiv == 'REVIEW') && item.completeYn == 'Y'">
                      수료증 발급
                      <i class="ico-arr-r wh back"></i>
                    </span>
                    <span class="btn spot4 wfix" v-if="(item.periodDiv == 'FINISH' || item.periodDiv == 'REVIEW') && item.completeYn == 'N'">
                      미수료
                      <i class="ico-arr-r wh back"></i>
                    </span>
                    <h3>{{ item.categoryNm }}</h3>
                    <p>{{ item.subjNm }}</p>
                    <ul>
                      <li>
                        <span>교육기간</span>
                        <span>{{ item.learnStartDt | dateMiniFormat }}~{{ item.learnEndDt | dateMiniFormat }}</span>
                      </li>
                      <li v-if="item.periodDiv == 'BEFORE'"><span>교육 진행 전</span></li>
                      <li v-if="item.periodDiv == 'EDU'"><span>교육 진행 중</span></li>
                      <li v-if="item.periodDiv == 'FINISH' || item.periodDiv == 'REVIEW'"><span>교육 종료</span></li>
                    </ul>
                  </a>
                </li>
                <li v-if="resultLearnList != null && resultLearnList.length == 0">
                  <el-skeleton :loading="loading" :count="2" animated>
                    <template slot="template">
                      <li>
                        <el-skeleton-item style="height: 145px; width: 100%" />
                      </li>
                    </template>
                    <template>
                      <p class="msg">진행중인 강의가 없습니다.</p>
                    </template>
                  </el-skeleton>
                </li>
              </ul>

              <div class="my-qna">
                <h3>나의 Q&A</h3>
                <ul>
                  <li>
                    <router-link to="/usr/bbs/10007">
                      <cite>등록</cite>
                      <el-skeleton :loading="loading" animated>
                        <template slot="template">
                          <el-skeleton-item style="height: 20px; width: 30%" />
                        </template>
                        <template>{{ resultQnaSummary.qnaCnt }}건</template>
                      </el-skeleton>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/usr/bbs/10007">
                      <cite>답변</cite>
                      <el-skeleton :loading="loading" animated>
                        <template slot="template">
                          <el-skeleton-item style="height: 20px; width: 30%" />
                        </template>
                        <template>{{ resultQnaSummary.replyCnt }}건</template>
                      </el-skeleton>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <router-link to="/usr/mypage" class="btn-more">
              마이페이지 바로가기
              <i class="ico-arr-bar-r back"></i>
            </router-link>
          </section>

          <section class="mn-notice">
            <h2 class="mn-tit">자료실</h2>
            <ul>
              <li v-for="item in resultDataList" :key="item.postsSeqno">
                <router-link :to="`/usr/bbs/10008/${item.postsSeqno}`">
                  <span class="time">{{ item.regDt | dateMiniFormat }}</span>
                  <p>{{ item.title }}</p>
                </router-link>
              </li>
            </ul>
            <router-link to="/usr/bbs/10008" class="btn-more">
              자료실 더보기
              <i class="ico-arr-bar-r back"></i>
            </router-link>
          </section>
        </div>
      </div>
      <section class="mn-lnk">
        <div class="wrap">
          <h2 class="txt-hide">안내</h2>
          <ul>
            <li>
              <a @click="getPopup('/user/intro/popup/IntroBusinessProcess.do#tabs-pop01')">
                신규 및 기존영업자(허가/신고/변경절차) 제조업, 판매업
                <i class="ico-arr-round-r back"></i>
              </a>
            </li>
            <li>
              <router-link to="/usr/bbs/10030/115599">
                건강기능식품 안전위생 (보수)교육신청 안내
                <i class="ico-arr-round-r back"></i>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <div class="wrap">
        <div class="mn-row">
          <section class="mn-cs">
            <h2>고객센터</h2>
            <dl>
              <dt>교육지원</dt>
              <dd>
                <em class="spot">1661-2371</em>
                <span>평일 9시 ~ 18시</span>
              </dd>
            </dl>
            <a href="https://helpu.kr/khff" class="btn-remote" target="_blank" v-if="!isMobile()">
              <i class="ico-remote wh"></i>
              원격지원
              <i class="ico-arr-r wh back"></i>
            </a>
          </section>
          <section class="mn-quick">
            <h2 class="txt-hide">퀵메뉴</h2>
            <ul>
              <li>
                <router-link to="/usr/bbs/10005/119473">
                  <i class="ico-quick1" aria-hidden="true"></i>
                  <span>
                    법정교육
                    <br />
                    안내공문
                  </span>
                </router-link>
              </li>
              <li>
                <router-link to="/usr/bbs/10005/101041">
                  <i class="ico-quick2" aria-hidden="true"></i>
                  <span>
                    대표자변경
                    <br />
                    사유서
                  </span>
                </router-link>
              </li>
              <li>
                <router-link to="/usr/mypage">
                  <i class="ico-quick3" aria-hidden="true"></i>
                  <span>영수증 발급</span>
                </router-link>
              </li>
              <li>
                <router-link to="/usr/enroll/search">
                  <i class="ico-quick4" aria-hidden="true"></i>
                  <span>교육수료조회</span>
                </router-link>
              </li>
              <li>
                <router-link to="/usr/myclass/cert">
                  <i class="ico-quick5" aria-hidden="true"></i>
                  <span>수료증 발급</span>
                </router-link>
              </li>
              <li>
                <router-link to="/usr/myclass/agent">
                  <i class="ico-quick6" aria-hidden="true"></i>
                  <span>
                    지정확인서
                    <br />
                    발급
                  </span>
                </router-link>
              </li>
            </ul>
          </section>
        </div>
        <div class="mn-row btn-flex">
          <a href="https://cert.khff.or.kr/" target="_blank" class="btn-xlg spot-gradient">
            건강기능식품 민간 자격증 바로가기
            <i class="ico-arr-r wh back"></i>
            <span class="deco-certi"><img :src="assetsURL + '/images/user2022/main/img_certi.png'" alt="" /></span>
          </a>
        </div>
      </div>
    </div>
    <!-- //mn-contents -->

    <div class="mn-popup-area">
      <div v-for="(item, index) in resultPopupList" :key="item.postsSeqno" class="popup" :style="`${item.width != null ? 'width: ' + item.width + 'px;' : 'auto'}; display:${item.visiblePop ? '' : 'none'}`">
        <div class="pop-body" v-if="item.imgAttachId == null || item.contentsShort != null">
          <h3><span v-html="item.title"></span></h3>
          <span v-html="item.contentsShort"></span>
        </div>
        <div class="pop-bnn" v-if="item.imgAttachId != null">
          <template v-if="item.siteLink != null">
            <a :href="item.siteLink" target="_blank"><file-img-view v-model="item.imgAttachId" repository-id="board" /></a>
          </template>
          <template v-else>
            <file-view v-model="item.imgAttachId" repository-id="board" />
          </template>
        </div>

        <div class="pop-footer">
          <div class="btn-cont">
            <router-link :to="`/usr/bbs/${item.boardSeqno}/${item.postsSeqno}`" class="btn spot">내용 자세히 보기</router-link>
          </div>
          <div class="today-close">
            <div class="checkradio">
              <input type="checkbox" ref="chkPopup" :id="`chkNotice_${item.postsSeqno}`" @click="setNoticeClose(item, index)" />
              <label :for="`chkNotice_${item.postsSeqno}`">오늘 하루 열지 않음</label>
            </div>
          </div>
        </div>
        <button type="button" class="pop-close" @click="setNoticeClose(item, index)">팝업닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { assetsURL, apiURL, siteURL } from "@/utils";

export default {
  name: "main-body",
  components: {},
  data() {
    return {
      loading: true,
      assetsURL: assetsURL,
      resultNoticeList: [],
      resultDataList: [],
      resultFaqList: [],
      resultLearnList: [],
      resultPopupList: [],
      resultQnaSummary: {},
    };
  },
  watch: {
    $route: function (to, from) {},
  },
  created() {
    this.getList();
    this.$nextTick(() => {
      $(".mn-top").mnTopSlick();
    });
  },
  methods: {
    getList() {
      this.request(`${apiURL}/main/list`).then(({ data }) => {
        this.resultNoticeList = data.resultNoticeList;
        this.resultDataList = data.resultDataList;
        this.resultFaqList = data.resultFaqList;

        data.resultPopupList.forEach((item, index) => {
          item.chkPopup = "N";
          item.visiblePop = true;
          if (this.$cookies.get("notice_" + item.postsSeqno) != null) {
            item.visiblePop = false;
          }

          if (item.contentsShort != null) {
            item.contentsShort = item.contentsShort.replace(/http:\/\/khsa-attach.s3.ap-northeast-2.amazonaws.com/gi, "https://educdn.khff.or.kr");
          }
        });
        this.resultPopupList = data.resultPopupList;
        this.resultLearnList = data.resultLearnList != null ? data.resultLearnList : [];
        this.resultQnaSummary = data.resultQnaSummary != null ? data.resultQnaSummary : {};

        this.loading = false;
      });
    },
    getMyClass(item) {
      this.$router.push(`/usr/learn/main/${item.enrollNo}`);
    },
    getPopup(url) {
      if (this.isApp()) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ action: "popup", url: siteURL + url }));
        return;
      }

      window.open(siteURL + url, "", "width=1000, height=800, scrollbars=1");
    },
    setNoticeClose(item, idx) {
      if (this.$refs.chkPopup[idx].checked) {
        this.$cookies.set("notice_" + item.postsSeqno, item.postsSeqno, {
          path: "/",
          expire: 1,
        });
      }

      item.visiblePop = false;
      this.$forceUpdate();
    },
    goUrl(url) {
      this.$router.push(url);
    },
  },
  computed: {
    ...mapGetters(["routeParams", "currentUser"]),
  },
};
</script>
